export { WebReserveReceptionLinkModule } from './web-reserve-reception-link.module';
export { WebReserveReceptionLinkComponent } from './web-reserve-reception-link.component';
export { WebReserveReceptionLinkService } from './web-reserve-reception-link.service';



// WEBPACK FOOTER //
// ./src/app/feature/web-reserve-reception-link/index.ts